import posthog from "posthog-js";
import { ENVIRONMENT, POSTHOG_API_KEY, POSTHOG_CONFIG } from "./config";
import { Environment } from "./types";

/* initialize posthog if not in local environment */
export function initialize(): void {
  if (ENVIRONMENT === Environment.Local) return void 0;
  posthog.init(POSTHOG_API_KEY, POSTHOG_CONFIG);
}
